// Copyright (c) StrangeBee 2024

import { ListActionType } from '@Types';

export type ActionListRendererParams<T> = (
    selectedItems: T[],
    onSuccess: (count?: boolean) => void,
    from?: 'list' | 'details',
) => {
    [key: string]: ListActionType;
};

export const actionListRenderer = <T>(actionList: ActionListRendererParams<T>): ActionListRendererParams<T> =>
    actionList;
